export const BUDGET_OPTIONS = [
  { label: '< 100.000 €', value: '<100000', range: { max: 100000 } },
  {
    label: 'tra 100.000 e 250.000 €',
    value: '100000-250000',
    range: { min: 100001, max: 250000 },
  },
  {
    label: 'tra 250.000 e 500.000 €',
    value: '250000-500000',
    range: { min: 250001, max: 500000 },
  },
  {
    label: 'tra 500.000 e 1.000.000 €',
    value: '500000-1000000',
    range: { min: 500001, max: 1000000 },
  },
  {
    label: '> 1.000.000 €',
    value: '>1000000',
    range: { min: 1000001 },
  },
];

export const CONTRIBUTO_FC_OPTIONS = [
  { label: '< 50.000 €', value: '<50000', range: { max: 50000 } },
  {
    label: 'tra 50.000 e 100.000 €',
    value: '50000-100000',
    range: { min: 50001, max: 100000 },
  },
  {
    label: 'tra 100.000 e 200.000 €',
    value: '100000-200000',
    range: { min: 100001, max: 200000 },
  },
  {
    label: 'tra 200.000 e 500.000 €',
    value: '200000-500000',
    range: { min: 200001, max: 500000 },
  },
  {
    label: '> 500.000 €',
    value: '>500000',
    range: { min: 500001 },
  },
];

export const getOptionByValue = (options, value) => {
  const f = options.filter((o) => o.value === value);
  return f?.length > 0 ? f[0] : null;
};
